<template>
  <div>
    <el-tag v-for="(item,index) in scope.row[config.prop]"
            size="mini" :key="index">
      {{ getLabelFormList(item) }}
    </el-tag>
  </div>
</template>

<script>
import { PIC_API as picAPI } from "@/utils/common";
import genApi, { get } from "@/quick/gen-api";
import baseMap from './base_map'
export default {
  name: "TMap",
  cName:'映射值',
  mixins:[baseMap],
  // functional: true,
  // Props 是可选的
  props: ["scope"],
  
};
</script>
